// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"e627b865","154":"50e4a142"}[chunkId] + ".chunk.js";
};